import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getSalesforceCrmSettings, saveSalesforceCrmSettings} from 'src/openapi/admin/apis/SalesforceControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SalesforceAccountSettings} from 'src/openapi/admin/models/SalesforceAccountSettings';

type Props = {
    accountId: number,
};

export const useSalesforceSettings = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getSalesforceCrmSettings({accountId}),
    ), [accountId, apiDispatch]);

    const saveDispatchAction = useCallback((salesforceAccountSettings: SalesforceAccountSettings) => apiDispatch(
        saveSalesforceCrmSettings({
            accountId,
            salesforceAccountSettings,
        }),
    ), [accountId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        shouldLoadData: false,
        initValue: {
            accountSettings: {
                autoLinkEnabled: false,
                autoSyncEnabled: false,
                importEnabled: false,
            },
            contactSettings: {
                autoLinkEnabled: false,
                autoSyncEnabled: false,
                importEnabled: false,
            },
            leadSettings: {
                autoSyncEnabled: false,
                autoLinkEnabled: false,
                importEnabled: false,
            },
            alertsEnabled: false,
            classicDomain: '',
            lightningDomain: '',
        },
    });
};
